import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  standalone: true,
  templateUrl: './restricted-layout.component.html',
  styleUrls: ['./restricted-layout.component.scss'],
  imports: [RouterOutlet]
})
export class RestrictedLayoutComponent {}
